/**
 * Decides if the supplied variable is variant label
 */
export function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}
//# sourceMappingURL=is-variant-label.js.map